import React from 'react';
import Hero from './Hero';
import Details from './Details';
import Action from './CallToAction';
import Wedge from './Wedge'

function Landing() {
  return (
    <div>
      <Hero/>
      <Details />
      <Action />
      <Wedge />
    </div>
  )
}

export default Landing
